import app from '@/app';

app.constant('VERSION', PAVRUNNER_VERSION)
	.constant('DEBUG_INFO_ENABLED', false)
	.constant('DEFAULT_LANGUAGE', 'pt-br')
	.constant('PAGE_SIZES', [10, 25, 100, 250, 1000])
	.constant('SMALL_PAGE_SIZES', [2, 5, 10, 30])
	.constant('ITEMS_PER_PAGE', 10);
